import "../css/Menu.css";

import { Link } from "react-router-dom";

function Menu({ categories, willItClose, setIsOpen }) {
  return (
    <div
      className={`menu ${
        willItClose ? "vanishes" : "appears"
      } d-flex justify-content-center align-items-center`}
    >
      <div className="text-center d-flex flex-column">
        <Link to="/" className="fs-5 menu-option" onClick={() => setIsOpen(false)}>
          HOME
        </Link>
        <Link to="/about" className="fs-5 menu-option" onClick={() => setIsOpen(false)}>
          ABOUT
        </Link>
        {categories.map((category) => (
          <Link
            to={`/categories/${category.slug}`}
            className="fs-5 menu-option"
            onClick={() => setIsOpen(false)}
            key={category.slug}
          >
            {category.name.toUpperCase()}
          </Link>
        ))}
        <Link to="/contact" className="fs-5 menu-option" onClick={() => setIsOpen(false)}>
          CONTACT US
        </Link>
      </div>
    </div>
  );
}

export default Menu;
